import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';


const Header = () => {
  return (
    <header className='shadow-lg'>
      <div className="logo ">
        <Link to="#home"><img src="files/logo2.png" class="mx-5 w-20 h-12"></img></Link>
      </div>
      <nav>
        <ul className="nav-links">
          <li><a onClick={()=>document.getElementById("home").scrollIntoView({behavior:'smooth'})}>Home</a></li>
          <li><a onClick={()=>document.getElementById("projects").scrollIntoView({behavior:'smooth'})}>Projects</a></li>
          <li><a onClick={()=>document.getElementById("experiences").scrollIntoView({behavior:'smooth'})}>Experience</a></li>
        </ul>
        <div className="menu-icon">
          <i className="fas fa-bars"></i>
        </div>
      </nav>
    </header> 
  );
};

export default Header;
